import { SearchInput } from "@jugl-web/ui-components/cross-platform/SearchInput";
import { useTranslations } from "@jugl-web/utils";
import { useBoardTemplates } from "../../../../hooks/useBoardTemplates";
import { useBoardTemplatesModalProvider } from "../../../../providers/useBoardTemplatesModalProvider";

export const Header = () => {
  const { selectedCategory, resetSearchQuery, searchInputProps } =
    useBoardTemplatesModalProvider();

  const { totalEntries } = useBoardTemplates({
    category: selectedCategory,
  });

  const { t } = useTranslations();
  return (
    <div className="font-secondary flex h-[104px] w-full items-center justify-between gap-10 border-0 border-b border-solid border-[#DFE2E3] bg-white pl-[64px] pr-10">
      <div className="flex flex-col">
        <div className="max-w-1/2 truncate text-[22px] font-medium text-black">
          {selectedCategory === "popular-templates"
            ? t({
                id: "board-templates-header.popular-templates",
                defaultMessage: "Popular Templates",
              })
            : selectedCategory}
        </div>
        <div className="text-sm text-[#828282]">
          {totalEntries || 0}{" "}
          {t({
            id: "board-templates-header.templates",
            defaultMessage: "Templates",
          })}
        </div>
      </div>
      <div className="flex flex-row gap-8">
        <SearchInput
          key={selectedCategory}
          className="w-[300px]"
          placeholder="Search"
          variant="filled"
          color="grey"
          {...searchInputProps}
          onClear={resetSearchQuery}
        />
      </div>
    </div>
  );
};
